import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const COOKIE_KEY = "cookie_consent";

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);
  const { t, lang } = useI18n();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-cookie-banner className="fixed bottom-0 left-0 right-0 z-[9999] p-4 animate-in slide-in-from-bottom-4 duration-500">
      <div className="max-w-3xl mx-auto bg-card border gold-border rounded-2xl p-5 shadow-gold flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="w-6 h-6 text-gold shrink-0 mt-0.5 sm:mt-0" />
        <div className="flex-1 text-sm text-foreground/70 leading-relaxed">
          {t("cookie.message")}{" "}
          <a href={`/${lang}/polityka-cookies`} className="text-gold hover:underline">
            {t("cookie.learnMore")}
          </a>{" "}
          <a href={`/${lang}/polityka-prywatnosci`} className="text-gold hover:underline">
            Polityka prywatności
          </a>
        </div>
        <Button
          onClick={accept}
          className="bg-gold-gradient shadow-gold shrink-0 text-sm"
          size="sm"
        >
          {t("cookie.accept")}
        </Button>
      </div>
    </div>
  );
}
